import React from 'react';
import { useSelector } from 'react-redux';
import { getRailbillingMethods } from 'src/slices/railbillingMethods';
import FormSelect from 'shared/forms/FormSelect';

const RailbillingMethodDropdown = (props) => {

  const methods = useSelector(getRailbillingMethods);
  return (
    <FormSelect
      data={methods}
      textField="description"
      dataItemKey="value"
      {...props}
    />
  );
};

export default RailbillingMethodDropdown;